import { render, staticRenderFns } from "./nav-configuration.vue?vue&type=template&id=741d85bd&scoped=true&"
import script from "./nav-configuration.vue?vue&type=script&lang=ts&"
export * from "./nav-configuration.vue?vue&type=script&lang=ts&"
import style0 from "./nav-configuration.vue?vue&type=style&index=0&id=741d85bd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "741d85bd",
  null
  
)

export default component.exports